module.exports = __webpack_public_path__ + "img/logo_slogan_bottom.5c6521cb.svg";